<template>
    <div id="the-page">
        <Header/>
        <div class="page-section">
            <main id="scrollable-content">
                <slot />
            </main>
        </div>
        <Footer/>
    </div>
</template>

<script>
import Header from "./partial/Header"
import Footer from "./partial/Footer"

export default {
    name: 'LayoutError',
    components: {
        Header,
        Footer
    },
}
</script>

<style>

</style>
